/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import React, {useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {Topbar} from './Topbar'
import {useIntl} from 'react-intl'
import {useDispatch, useSelector} from 'react-redux'
import {Modal} from 'react-bootstrap'
import {useThemeMode} from '../../../partials/layout/theme-mode/ThemeModeProvider'
import {setIsThereNonSavedForm} from '../../../../app/common/ModalPopup/reducer'

export function HeaderWrapper() {
  const intl = useIntl()
  const {config, classes, attributes} = useLayout()
  const {aside} = config

  const isThereNonSavedForm = useSelector((state: any) => state?.isThereNonSavedForm)
  const [showCancel, setShowCancel] = useState<boolean>(false)
  const [w2go, setW2go] = useState<string>('')
  const navigate = useNavigate()
  const {mode} = useThemeMode()
  const dispatch = useDispatch()

  const checkEditNonSaved = (e: any, routeName: string) => {
    setW2go(routeName)
    if (isThereNonSavedForm === true) {
      setShowCancel(true)
    } else {
      navigate(routeName)
    }
  }

  const onCancelReset = () => {
    setShowCancel(false)
  }

  const onConfirmCancel = () => {
    setShowCancel(false)
    dispatch(setIsThereNonSavedForm(false))
    navigate(w2go)
  }

  return (
    <div
      id='kt_header'
      className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
      data-kt-sticky='true'
      data-kt-sticky-name='header'
      data-kt-sticky-offset="{default: '200px', lg: '300px'}"
      {...attributes.headerMenu}
    >
      <div
        className={clsx(
          classes.headerContainer.join(' '),
          'd-flex align-items-center justify-content-between'
        )}
      >
        {/* begin::Aside mobile toggle */}
        {aside.display && (
          <div className='d-flex align-items-center d-lg-none ms-n3 me-1' title='Show aside menu'>
            <div
              className='btn btn-icon btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40px'
              id='kt_aside_mobile_toggle'
            >
              <KTIcon iconName='abstract-14' className='fs-2x mt-1' />
            </div>
          </div>
        )}
        <div className='header-logo me-5 me-md-10 flex-grow-1 flex-lg-grow-0'>
          <Link
            to='/home'
            onClick={(e) => {
              e.preventDefault()
              checkEditNonSaved(e, '/home')
            }}
          >
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/images/Logo-dark2.png')}
              className={clsx('logo-default h-100px', {'d-none': mode === 'light'})}
            />
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/logos/demo2.png')}
              className={clsx('logo-default h-100px', {'d-none': mode === 'dark'})}
            />
          </Link>
        </div>

        {/* begin::Wrapper */}
        <div className='page-title d-none d-sm-none d-md-none d-lg-none d-xl-flex align-items-center justify-content-center flex-lg-grow-1'>
          <div
            className='d-flex align-items-center text-white text-sticky-primary fw-500'
            id='kt_header_nav'
            style={{fontSize: 24}}
          >
            {intl.formatMessage({id: 'TITLE'})}
          </div>
        </div>
        <div className='page-title d-none d-sm-none d-md-flex d-lg-flex d-xl-none align-items-center justify-content-center'>
          <div
            className='d-flex align-items-center text-white text-sticky-primary fw-500'
            id='kt_header_nav'
            style={{fontSize: 16}}
          >
            {intl.formatMessage({id: 'TITLE'})}
          </div>
        </div>
        <div className='d-flex align-items-stretch flex-shrink-0'>
          <Topbar />
        </div>
        {/* end::Wrapper */}
      </div>
      <Modal show={showCancel} centered>
        <div className='text-center p-5 w-100' data-bs-theme={mode}>
          <div
            className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
            data-bs-theme={mode}
          >
            <div className='d-flex align-items-center justify-content-between'>
              <div className='fw-bolder text-gray-700 py-3'>
                {intl.formatMessage({id: 'INFORMATION'})}
              </div>
              <div className='p-1 cursor-pointer' onClick={onCancelReset}>
                <i className='fa fa-close text-danger'></i>
              </div>
            </div>
            <div className={'text-start py-3'}>
              <div>{intl.formatMessage({id: 'BEFORE_QUIT_CONFIRM_MESSAGE'})}</div>
            </div>
            <div className='d-flex align-items-center justify-content-evenly'>
              <button className={'btn btn-secondary'} onClick={onCancelReset}>
                {intl.formatMessage({id: 'NO'})}
              </button>
              <button className={'btn btn-primary'} onClick={onConfirmCancel}>
                {intl.formatMessage({id: 'YES'})}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}
